var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"px-5 py-3"},[_c('b-table',{attrs:{"responsive":"","striped":"","items":_vm.miembros,"fields":_vm.fields,"table-variant":"warning"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }